import Highcharts from 'highcharts/es-modules/masters/highcharts.src';

// Position checkboxes to the left (instead of Highchart's default of right).
// https://stackoverflow.com/a/19180138/222487
// Based on:
// https://github.com/highcharts/highcharts/blob/v11.3.0/ts/Core/Legend/Legend.ts#L517-L546
// But with further tweaks to ensure checkbox alignment regardless of checkbox
// margins (eg, with Bootstrap stripping default margins).
Highcharts.wrap(Highcharts.Legend.prototype, 'positionCheckboxes', function highchartsLeftPositionCheckboxPatch() {
  const alignAttr = this.group && this.group.alignAttr;
  const clipHeight = this.clipHeight || this.legendHeight;
  const { titleHeight } = this;
  let translateY;
  let checkboxMarginTop;

  if (alignAttr) {
    translateY = alignAttr.translateY;
    this.allItems.forEach((item) => {
      const { checkbox } = item;
      const bBox = item.legendItem.group.getBBox();
      let top;

      // Try to vertically align to the symbol in the legend, since that will
      // be closest to the checkbox for vertical alignment purposes.
      let alignToBBox = bBox;
      if (item.legendItem.symbol) {
        alignToBBox = item.legendItem.symbol.getBBox();
      }

      if (checkbox) {
        // Determine any margins on the checkbox, since that alters
        // positioning.
        if (checkboxMarginTop === undefined) {
          const checkboxStyles = window.getComputedStyle(checkbox);
          checkboxMarginTop = parseInt(checkboxStyles.marginTop, 10);
        }

        top = translateY +
          titleHeight +
          (this.scrollOffset || 0) +
          item.legendItem.y +
          alignToBBox.y +
          (alignToBBox.height / 2) -
          checkboxMarginTop -
          (checkbox.scrollHeight / 2);

        Highcharts.css(checkbox, {
          left: `${alignAttr.translateX - checkbox.scrollWidth - 2}px`,
          top: `${top}px`,
          display: this.proximate || (Math.ceil(top) > translateY - (checkbox.scrollHeight / 2) && Math.floor(top) < translateY + clipHeight - (checkbox.scrollHeight / 2)) ? '' : 'none',
        });
      }
    }, this);
  }
});
